exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".holder__Qjf {\n  margin: 0 auto;\n  padding: 0 40px 60px;\n  width: 1120px; }\n  .holder__Qjf.withTopPadding__34Z {\n    padding-top: 60px; }\n  .holder__Qjf > h2 {\n    margin: 0 0 24px;\n    padding-top: 40px;\n    text-align: center;\n    font-size: 26px;\n    font-weight: 300;\n    color: #47689f; }\n\n.separator__2bA {\n  height: 60px; }\n", ""]);
// Exports
exports.locals = {
	"holder": "holder__Qjf",
	"withTopPadding": "withTopPadding__34Z",
	"separator": "separator__2bA"
};